<template>
  <table class="w-100">
    <thead>
      <tr>
        <th>{{ i18n.global.t('pages.dailyReports.carNumber') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.overView.leavingWarehouse') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.overView.leavingWarehouseMeter') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.overView.returningWarehouse') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.overView.returningWarehouseMeter') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.overView.totalMileage') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.overView.actualVehicleDistance') }}</th>
        <th>{{ i18n.global.t('pages.dailyReports.updateModal.overView.roadDistance') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{deliveryPlan?.car_number}}</td>
        <td>{{deliveryPlan?.leaving_warehouse_date_time}}</td>
        <td>{{roundForView(parseFloat(deliveryPlan?.out_of_service_meter))}}</td>
        <td>{{deliveryPlan?.returning_warehouse_date_time}}</td>
        <td>{{roundForView(parseFloat(deliveryPlan.out_of_service_meter) + parseFloat(deliveryPlan.total_mileage))}}</td>
        <td>{{roundForView(deliveryPlan?.total_mileage)}}</td>
        <td>{{roundForView(deliveryPlan?.actual_vehicle_distance)}}</td>
        <td>
          {{roundForView(deliveryPlan?.general_speed_distance)}}
          /{{roundForView(deliveryPlan?.high_speed_distance)}}
          /0.00
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import {
  round
} from "@/services/functions";
import i18n from '@/lang/i18n';

export default {
  setup() {
    return {
      round,
      i18n
    }
  },
  props: {
    deliveryPlan: {},
  },
  methods: {
    roundForView(num) {
      return round(num,2).toFixed(2)
    }
  },
  components: {
  },
}
</script>

<style>
</style>
